<page-layout [settings]="layout.layoutSettings()!"></page-layout>
<toaster></toaster>
